import React from 'react'
import { Grid, Icon, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
let dependencySelected = '';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class Dependency extends React.Component {
    constructor(props) {
        super(props);
        this.removeDependency = this.removeDependency.bind(this);
    }
    componentWillMount() {

    }
    setSelectedDependency(data) {
        switch (data.target.name) {
            case 'dependency': dependencySelected = data.target.value ? data.target.value : '';
        }
    }

    getMapping(id) {
        if (this.props.activityOptions) {
            for (let i = 0; i < this.props.activityOptions.length; i++) {
                let activity = this.props.activityOptions[i];
                if (id.toString() === activity._id.toString()) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id.toString() === subActivity._id.toString()) {
                            return activity.name + " > " + subActivity.name;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (id.toString() === childActivity._id.toString()) {
                                    return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                                }
                            }
                        }
                    }
                }
            }
        }

    }
    removeDependency(id) {
        let index = this.props.selectedActivityData.dependencies.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Dependency</h3>
            <p>Are you sure that you wish to do this?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index !== -1) {
                    (this.props.selectedActivityData.dependencies).splice(index, 1)
                    if (this.props.selectedActivityData.dependencies.length == 0) {
                        this.props.selectedActivityData.runStatus = 0;
                    }
                    if (this.props.selectedActivityData.onHoldFlag == true) {
                        if (this.props.selectedActivityData && this.props.selectedActivityData.onHoldComments && this.props.selectedActivityData.onHoldComments.length > 0 && this.props.selectedActivityData.onHoldComments[0].isImplicitOnHold == false) {
                            this.props.selectedActivityData.onHoldFlag = false;
                        }
                    }
                    dispatch.initiatives.editActivityAsync(this.props.selectedActivityData)
                }
            }
        });
    }

    render() {
        let initiativeData;
        if (this.props.activeTab === 'myactivities') {
            initiativeData = this.props.selectedActivityData.initiativeId;
        } else {
            initiativeData = this.props.selectedDataById;
        }

        const showDeleteButton = (dependency) => {
            return (
                <Grid.Column width={2}>
                    <Button
                        className="trash-color"
                        icon="trash alternate"
                        style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}
                        onClick={() => this.removeDependency(dependency)}>

                    </Button>
                </Grid.Column>
            )

        }

        return initiativeData ?
            <Grid columns={2} >
                {this.props.selectedActivityData.dependencies && this.props.selectedActivityData.dependencies.map((dependency) => {
                    return (<Grid.Row key={dependency}>
                        <Grid.Column width={14}>
                            <div className="divBlock"> <Icon name="linkify" color="purple" /> &nbsp; &nbsp; {this.getMapping(dependency)}</div>
                        </Grid.Column>
                        {this.props.resourcePaneFlag === "ConfigureActivities" &&
                            (initiativeData.status === 0 || initiativeData.status === 1 || initiativeData.status === 2 ||
                                (initiativeData.status === 4 && (this.props.selectedActivityData.runStatus === -1 || this.props.selectedActivityData.runStatus === 0))) ?
                            showDeleteButton(dependency) : ''}
                    </Grid.Row>)

                })}


            </Grid> : null
    }
}

export default Dependency